import { createContext, useContext } from "react";
import { AddCrmModalSimplifiedContextProps } from "./AddCrmModalSimplifiedContext.types";

export const addCrmModalSimplifiedContext = createContext<AddCrmModalSimplifiedContextProps|null>(null);

export function useAddCrmModalSimplifiedContext() {
    const context =  useContext(addCrmModalSimplifiedContext);
    if (!context) {
        throw new Error("useAddCrmModalSimplifiedContext must be used within AddCrmModalSimplifiedContextProvider");
    }
    return context;
}